import { config } from '../config.js'
import { get } from '../services/http.js'

export async function getUserStats() {
  return get(`${config.apiUrl}/account/stats`)
}
